import { authClient } from '@frontend/api-clients/authClient';
import type { WidgetLayoutEntry } from './types';

export async function fetchWidgetData<T>(
	widgetId: string,
	params: Record<string, string>
): Promise<T> {
	const token = authClient.getToken();
	const search = new URLSearchParams(params);
	const response = await fetch(`/api/widgets/data/${encodeURIComponent(widgetId)}?${search}`, {
		headers: {
			'Content-Type': 'application/json',
			...(token ? { Authorization: `Bearer ${token}` } : {})
		}
	});
	const data = (await response.json()) as { message?: string } & T;
	if (!response.ok) {
		throw new Error(data.message || 'Failed to load widget data');
	}
	return data;
}

export async function fetchWidgetLayout(
	contextType: string,
	contextId: string,
	ecosystemId: string
): Promise<{ layout: WidgetLayoutEntry[] | null }> {
	const token = authClient.getToken();
	const search = new URLSearchParams({ contextType, contextId, ecosystemId });
	const response = await fetch(`/api/widgets/layouts?${search}`, {
		headers: {
			'Content-Type': 'application/json',
			...(token ? { Authorization: `Bearer ${token}` } : {})
		}
	});
	const data = (await response.json()) as { message?: string; layout: WidgetLayoutEntry[] | null };
	if (!response.ok) {
		throw new Error(data.message || 'Failed to load widget layout');
	}
	return data;
}

export async function saveWidgetLayout(
	contextType: string,
	contextId: string,
	ecosystemId: string,
	layout: WidgetLayoutEntry[]
): Promise<void> {
	const token = authClient.getToken();
	const response = await fetch('/api/widgets/layouts', {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
			...(token ? { Authorization: `Bearer ${token}` } : {})
		},
		body: JSON.stringify({ contextType, contextId, ecosystemId, layout })
	});
	const data = (await response.json()) as { message?: string };
	if (!response.ok) {
		throw new Error(data.message || 'Failed to save widget layout');
	}
}
